<div class="feature-locked">
  <div class="feature-locked__card">
    <span class="material-symbols-outlined feature-locked__icon">lock</span>
    <h1>Feature not included in your plan</h1>
    <p>
      <strong>{{ featureLabels }}</strong> is not enabled for your company on the current plan.
    </p>
    <p class="feature-locked__hint">
      Upgrade your subscription to unlock this feature, or contact support if you believe this is an error.
    </p>
    <div class="feature-locked__actions">
      <button mat-flat-button color="primary" type="button" (click)="goToPlans()">
        View plans &amp; billing
      </button>
      <button mat-stroked-button type="button" (click)="goBack()">
        Go back
      </button>
    </div>
  </div>
</div>
